import { ChangeDetectorRef, Component, inject, OnInit } from '@angular/core';
import { ErzeugungsanlageExportService } from '../../service/erzeugungsanlage/erzeugungsanlage-export.service';
import { NetzbetreiberService } from '../../service/netzbetreiber/netzbetreiber.service';
import { combineLatest, Observable } from 'rxjs';
import { Netzbetreiber } from '../../domain/model/netzbetreiber';
import { AbstractControl, UntypedFormControl, ValidatorFn } from '@angular/forms';
import { map, startWith } from 'rxjs/operators';


@Component({
    selector: 'redispatch-settings-erzeugnungsanlagen-export',
    templateUrl: './settings-erzeugnungsanlagen-export.component.html',
    styleUrls: [
        './settings-erzeugnungsanlagen-export.component.scss',
    ],
    standalone: false,
})
export class SettingsErzeugnungsanlagenExportComponent implements OnInit {

    public static isNetzbetreiber(): ValidatorFn {
        return (control: AbstractControl): { [key: string]: any } | null => {
            if (typeof control.value !== 'object') {
                return { noNetzbetreiber: true };
            }
            if (control.value.name === undefined || control.value.netzbetreibernummer === undefined || control.value.stadtwerkeId === undefined) {
                return { noNetzbetreiber: true };
            }
        };
    }

    myControl: UntypedFormControl;

    public netzbetreiberList$: Observable<Netzbetreiber[]>;
    public loadingSingle: boolean = false;
    public loadingAll: boolean = false;

    private netzbetreiberService = inject(NetzbetreiberService);
    private erzeugungsanlageExportService = inject(ErzeugungsanlageExportService);
    private changeDetectorRef = inject(ChangeDetectorRef);

    constructor() {
        this.myControl = new UntypedFormControl('', SettingsErzeugnungsanlagenExportComponent.isNetzbetreiber());
    }

    ngOnInit(): void {
        this.netzbetreiberList$ = combineLatest([
            this.netzbetreiberService.getAlleNetzbetreiber(),
            this.myControl.valueChanges.pipe(startWith('')),
        ]).pipe(
            map(([
                netzbetreiber,
                search,
            ]) => {
                return netzbetreiber.filter(value => {
                    if (typeof search === 'string') {
                        const lc = search.toLowerCase();
                        return value.name.toLowerCase().indexOf(lc) !== -1 ||
                            value.stadtwerkeId.toLowerCase().indexOf(lc) !== -1 ||
                            value.netzbetreibernummer.toLowerCase().indexOf(lc) !== -1;
                    } else {
                        return value.stadtwerkeId === (search as Netzbetreiber).stadtwerkeId;
                    }
                });

            }),
        );
    }

    displayFn(netzbetreiber: Netzbetreiber): string {
        return netzbetreiber ? `${netzbetreiber.name} - ${netzbetreiber.teilgebiet} (${netzbetreiber.netzbetreibernummer}, ${netzbetreiber.stadtwerkeId})` : '';
    }

    public export() {
        if (this.myControl.invalid || !this.myControl.value.stadtwerkeId) {
            return;
        }
        this.loadingSingle = true;
        this.exportErzeugungsanlagen(this.myControl.value.stadtwerkeId);
    }

    public exportAll() {
        this.loadingAll = true;
        this.exportErzeugungsanlagen();
    }

    private exportErzeugungsanlagen(stadtwerkeId?: string) {
        this.erzeugungsanlageExportService.exportErzeugungsanlagen(stadtwerkeId, null, true, () => {
            this.loadingSingle = false;
            this.loadingAll = false;
            this.changeDetectorRef.markForCheck();
        });
    }

}
